
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summarization/summarization",
      function () {
        return require("private-next-pages/summarization/summarization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summarization/summarization"])
      });
    }
  